<script lang="ts">
  import { createBubbler, stopPropagation } from 'svelte/legacy';

  const bubble = createBubbler();
  import {onDestroy, onMount} from 'svelte';
  import {closeDialog, dialogStates} from "$lib/stores/dialogStores";
  import CloseIcon from "$lib/icons/CloseIcon.svelte";

  interface Props {
    modalName?: string;
    showModal?: boolean;
    widthClasses?: string;
    bg?: string;
    heightClasses?: string;
    rounded?: string;
    shadow?: string;
    positionY?: string;
    positionX?: string;
    children?: import('svelte').Snippet;
  }

  let {
    modalName = 'modal',
    showModal = $bindable(false),
    widthClasses = 'w-full max-w-[400px]',
    bg = 'bg-primary-lightBlue/60 backdrop-blur-sm',
    heightClasses = 'max-h-[95vdh] max-h-[95vh]',
    rounded = 'rounded-2xl',
    shadow = 'shadow-xl',
    positionY = 'items-start md:items-center',
    positionX = 'justify-center',
    children
  }: Props = $props();

  const unsubscribe = dialogStates.subscribe((state: any) => {
    showModal = state[modalName];
  });

  onDestroy(() => {
    unsubscribe();
  });

  function close() {
    closeDialog(modalName);
  }

</script>

{#if showModal}
<div id="dialogOverlay" role="button" tabindex="-1" onkeydown={()=>null} onclick={() => close()} class="inset-0 cursor-default {bg} z-[98] {showModal ? 'fixed' : 'hidden'} flex {positionY} {positionX} animate-fadeIn">
  <div class="bg-primary-blue mx-2 mt-2 md:mt-0 md:mx-0 px-4 py-4 overflow-auto no-scrollbar hide-scrollbar {heightClasses} {rounded} {shadow} {widthClasses} relative animate-scaleIn cursor-default" role="button" tabindex="-1" onkeydown={()=>null} onclick={stopPropagation(bubble('click'))}>
    <button id="closeDialog" class="text-gray-500 hover:text-gray-700 absolute z-50 right-4 top-4" onclick={() => close()}>
      <CloseIcon />
    </button>
    {@render children?.()}
  </div>
</div>
{/if}
